import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, XCircle } from "@phosphor-icons/react";
import BrandMark from "../components/BrandMark";

export default function SignupCancelled() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md bg-white border border-zinc-300">
        <div className="bg-[#1A2332] text-white px-6 py-5 flex items-center gap-3">
          <BrandMark size={36} className="rounded-md" />
          <div>
            <div className="font-display text-lg font-bold leading-none">ezItemizer</div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-zinc-400 mt-1">
              Checkout cancelled
            </div>
          </div>
        </div>
        <div className="px-6 py-9 text-center">
          <XCircle size={48} weight="duotone" className="text-zinc-500 mx-auto" />
          <h1 className="font-display text-2xl font-bold mt-5 text-[#0F172A]">No worries</h1>
          <p className="mt-3 text-sm text-zinc-600">
            You backed out of checkout — no card was charged. You can pick up where you left off whenever you're ready.
          </p>
          <Link
            to="/signup"
            data-testid="signup-cancelled-retry"
            className="mt-7 inline-flex items-center gap-2 bg-[#FF9800] hover:bg-[#E68900] text-[#1A2332] font-bold py-3 px-5"
          >
            Try again
            <ArrowRight size={16} weight="bold" />
          </Link>
        </div>
      </div>
    </div>
  );
}
